export default __webpack_public_path__ + "static/media/ny.3daa30ff.png";